export const DEFAULT_ASSESSMENTS_LIMIT = 10;

export const DEFAULT_DEBOUNCE_DELAY = 500;
export const TIME_LIMIT_MIN = 0;
export const MINUTE_LIMIT_MAX = 59;
